module.exports = __webpack_public_path__ + "img/TRANSITIONS-SIGNATURE-2.73fc2b64.gif";